export interface IWidgetAdapter extends IWidgetAdapterConfig {
    loadData(): void
    removeWidgetContainer(): void
}

export interface IWidgetAdapterConfig {
   adLight: boolean
}

export abstract class AbstractWidgetAdapter implements IWidgetAdapter {
    public constructor(public el: Element, public adLight: boolean) {
        // attach the element to the class
        this.el = el
        // Remove widget html container if ad lite is true
        if (this.adLight === true) {
            this.removeWidgetContainer()
        } else {
            this.loadData()
        }
    }

    // define this function as abstract so all concrete implementations require it
    public abstract loadData(): void

    public removeWidgetContainer(): void {
        this.el.remove()
    }
}
